import React, { FC, ReactNode } from 'react'
import classNames from 'classnames'

import { GridContainer } from 'components/ui-kit'
import styles from './PageWrapper.module.scss'

interface Props {
  children?: ReactNode
  className?: string
}

export const PageWrapper: FC<Props> = ({ children, className }) => (
  <GridContainer className={classNames(styles.pageWrapper, className)}>{children}</GridContainer>
)
